"use strict";

define('components/password_meter',['zxcvbn'], function(zxcvbn) {

    var passwordMeterComponent = {

        init: function() {
            var password_input = $('input[name=new_password],input[name=password]');
            var password_meter = $('.password-meter .progress-bar');
            var password_error = $('.password-error');
            password_input.on('input', function(e) {
                if (password_input.val().length == 0) {
                    $('.password-meter').css('visibility', 'hidden');
                    password_error.html('&nbsp;');
                    return;
                }
                $('.password-meter').css('visibility', 'visible');

                if (password_input.val().length < 8) {
                    password_meter.attr('class', 'progress-bar progress-bar-danger short');
                    password_error.text('Passwords must be at least 8 characters long');
                    return;
                }
                password_error.html('&nbsp;')

                var result = zxcvbn(password_input.val());
                if (result.feedback.warning) {
                    password_error.text(result.feedback.warning);
                }

                if (result.score == 0) {
                    password_meter.attr('class', 'progress-bar progress-bar-danger');
                } else if (result.score == 1) {
                    password_meter.attr('class', 'progress-bar progress-bar-warning');
                } else if (result.score == 2) {
                    password_meter.attr('class', 'progress-bar progress-bar-info');
                } else {
                    password_meter.attr('class', 'progress-bar progress-bar-success');
                }

                $('input#password-strength').val(result.score)
            });
        },
    };

    return passwordMeterComponent;
});


